module.exports = __webpack_public_path__ + "static/icon-no-circle-white-bec258b733c930db2e5403c1601ab8e3.png";